import styled from "styled-components";

import InputField from "src/shared/components/Input";
import { SubmitButton } from "src/shared/contact-boxes/components/DrawerFormButtons/styled";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 380px;
  position: relative;
  width: 100%;

  textarea {
    height: 90px;
    resize: none;
  }

  button[type="submit"] {
    margin-top: 8px;
  }
`;

export const Input = styled(InputField)``;

export const Button = styled(SubmitButton)``;
